import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M17 13a5 5 0 015 5v1a2 2 0 01-2 2h-3.765a2.988 2.988 0 00.756-1.771L17 19v-1a5.994 5.994 0 00-2.682-5H17zm-2.425 1.505l.065.067a4.895 4.895 0 01.623.815 4.66 4.66 0 01.285.533 4.559 4.559 0 01.16.393l.01.029.048.14.009.03A5.016 5.016 0 0116 18v1a2 2 0 01-2 2H4a2 2 0 01-2-2v-1a5 5 0 015-5h4c.342 0 .677.034 1 .1h.001l.03.006.13.03-.16-.036a5.108 5.108 0 01.835.248 4.957 4.957 0 011.246.714l.025.02a4.969 4.969 0 01.39.345l.039.037.04.04zm-2.305-9.81l.033.048a4.032 4.032 0 01.604 1.397 4.036 4.036 0 01.087 1.082L13 7a4.08 4.08 0 01-.167 1.147 3.99 3.99 0 01-.563 1.157l-.02.028a5.374 5.374 0 01-.175.226 4 4 0 110-5.117l-.074-.086a4.046 4.046 0 01.25.313l.02.028zM15 3a4 4 0 11-2.25 7.307A4.978 4.978 0 0014 7a4.981 4.981 0 00-1.25-3.307A3.98 3.98 0 0115 3z",
      fill: "#2d6ded"
    }
  )
), t = l;
export {
  t as default
};
